import { render } from "./Bottombar.vue?vue&type=template&id=ee66d700&scoped=true&ts=true"
import script from "./Bottombar.vue?vue&type=script&lang=ts"
export * from "./Bottombar.vue?vue&type=script&lang=ts"

import "./Bottombar.vue?vue&type=style&index=0&id=ee66d700&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee66d700"]])

export default __exports__